import { z } from 'zod';
import { LandmarkSchema, PlotSchema, TracedPlaceSchema } from '../../models/place';
import { API_PREFIX, defineEndpoint } from '../endpoint';

/**
 * What the places panel shows: the world's recognizable places, the player's own plot and the
 * plots of every other town (while plots are provisional, until `HOME-*`), with where each
 * stands and where a walker arrives. The world is walked (no travel between zones): the panel
 * only orients.
 */
export const listPlaces = defineEndpoint({
  method: 'GET',
  path: `${API_PREFIX}/world/places`,
  access: 'session',
  response: z.object({
    /** Authored places the character knows (WORLD-DISCOVERY): the map shows nothing else. */
    landmarks: z.array(LandmarkSchema),
    /** The traces' places it knows (sites, landmarks, hamlets), never one it does not (OC-2). */
    traced: z.array(TracedPlaceSchema),
    /** Its own fixed lot (C9); null where it has none (`launch`). */
    home: PlotSchema.nullable(),
    /** Other characters' fixed lots, listed until `HOME-*` says how they are known. */
    towns: z.array(PlotSchema),
    /** Regions the character knows, by id. */
    regions: z.array(z.string()),
  }),
});
